import React, { useEffect, useState } from 'react';

import './index.scss';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/lab';
import TextField from '@mui/material/TextField';

const Datepicker = ({ onChange, reset, hasError, name }) => {
  const [val, setVal] = useState(null);

  useEffect(() => {
     reset && setVal(null);
  }, [reset])
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        label={`${name}*`}
        value={val}
        ampm={false}
        onChange={(value) => {
          setVal(value);
          onChange(value);
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  )
};

export default Datepicker;
